import { SvgIcon } from "@mui/material"

import { ReactComponent as AdjustmentsIcon } from "./adjustments.svg"

export const StatusAdjustmentsIcon = (props) => {
    return (
        <SvgIcon component={AdjustmentsIcon} {...props} inheritViewBox />
    )
}